const DEV_HOSTNAMES = ["localhost", "local.ambifi.com", "dev-app.ambifi.com", "127.0.0.1", "::1"];

export function isTruthyFeatureFlag(value) {
	if (value === true || value === 1) {
		return true;
	}

	if (typeof value !== "string") {
		return false;
	}

	switch (value.trim().toLowerCase()) {
		case "1":
		case "true":
		case "yes":
		case "on": {
			return true;
		}
		default: {
			return false;
		}
	}
}

export function getFeatureFlagValue(flagName = "", urlParams = null) {
	if (!flagName) {
		return undefined;
	}

	if (urlParams && Object.prototype.hasOwnProperty.call(urlParams, flagName)) {
		return urlParams[flagName];
	}

	if (typeof window === "undefined" || !window.location) {
		return undefined;
	}

	const searchValues = [window.location.search || ""];
	const hashValue = window.location.hash || "";
	const hashQueryIndex = hashValue.indexOf("?");
	if (hashQueryIndex !== -1) {
		searchValues.push(hashValue.substring(hashQueryIndex));
	}

	for (let i = 0; i < searchValues.length; i += 1) {
		try {
			const params = new URLSearchParams(searchValues[i]);
			const value = params.get(flagName);
			if (value !== null) {
				return value;
			}
		} catch (err) {
			// Continue checking other URL surfaces.
		}
	}

	return undefined;
}

export function isDevHost() {
	if (typeof window === "undefined" || !window.location || !window.location.hostname) {
		return false;
	}

	return DEV_HOSTNAMES.includes(window.location.hostname);
}

export function isProdUiForced(urlParams = null) {
	return (
		isTruthyFeatureFlag(getFeatureFlagValue("forceProdUi", urlParams))
		|| isTruthyFeatureFlag(getFeatureFlagValue("prodPreview", urlParams))
	);
}

export function isDevFeatureEnvironment(urlParams = null) {
	return isDevHost() && !isProdUiForced(urlParams);
}

export function isFutureEnabled(urlParams = null) {
	return (
		isDevFeatureEnvironment(urlParams)
		|| isTruthyFeatureFlag(getFeatureFlagValue("future", urlParams))
		|| isTruthyFeatureFlag(getFeatureFlagValue("futureAi", urlParams))
	);
}

export function isFutureAiEnabled(urlParams = null) {
	return isDevFeatureEnvironment(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("futureAi", urlParams));
}

export function isAdminToolsEnabled(urlParams = null) {
	return isDevFeatureEnvironment(urlParams) || isFutureEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("adminTools", urlParams));
}

export function isBlockBankEnabled(urlParams = null) {
	return isTruthyFeatureFlag(getFeatureFlagValue("blockBank", urlParams));
}

export function isMediaToolsEnabled(urlParams = null) {
	return isDevFeatureEnvironment(urlParams) || isFutureEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("mediaTools", urlParams));
}

export function isImageToolsEnabled(urlParams = null) {
	return (
		isDevFeatureEnvironment(urlParams)
		|| isFutureEnabled(urlParams)
		|| isTruthyFeatureFlag(getFeatureFlagValue("imageTools", urlParams))
		|| isMediaToolsEnabled(urlParams)
	);
}

export function isAiAssistantFeatureEnabled(urlParams = null) {
	return isFutureAiEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("aiAssistant", urlParams));
}
